"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNumber = _interopRequireDefault(require("./isNumber"));

var isNotNumber = function isNotNumber(numToTest) {
  return !(0, _isNumber["default"])(numToTest);
};

var _default = isNotNumber;
exports["default"] = _default;